import { SubHeader } from '@components/header/base/subheader/sub-header.comp';
import { SubheaderItem } from '@components/header/base/subheader/sub-header-item';
import useProcess from '@hooks/useProcess';
import useStores from '@hooks/useStore';
import {
  getDraftProcessMenuItems,
  getStratumnProcessMenuItems
} from '@pages/Settings/menu';
import { hasElevatedRights } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { useUser } from '@/layout';
import { ParamsList } from '@/routes/routes.types';

export const ProcessLayout = () => {
  const process = useProcess();
  const { user } = useUser();
  const { envVarStore } = useStores();
  const processId = useParams()[ParamsList.ProcessId];
  if (!processId) {
    throw new Error('Missing processId route param');
  }
  const isPrivileged = hasElevatedRights(user);

  useEffect(() => {
    envVarStore.fetchEnvVars(processId);
  }, [processId, envVarStore]);

  const hasEnvVars = envVarStore.envVars.some(v => v.shared);

  const PROCESS_MENU_ITEMS = process?.draft
    ? getDraftProcessMenuItems({
        isWorkspaceFeatureEnabled: process.isWorkspaceFeatureEnabled,
        isPrivileged,
        hasEnvVars
      })
    : getStratumnProcessMenuItems({ isPrivileged, hasEnvVars });
  const canEdit = process?.permission.can_edit;

  const navigate = (link: string) => `/${processId}/${link}`;
  return (
    canEdit && (
      <div className="flex min-h-0 flex-1 flex-col">
        {canEdit && (
          <SubHeader>
            {PROCESS_MENU_ITEMS.map(({ name, link }) => (
              <SubheaderItem
                key={link}
                link={link}
                name={name}
                to={navigate(link)}
              />
            ))}
          </SubHeader>
        )}
        <div className="min-h-0 flex-1 overflow-hidden">
          <Outlet context={{ user }} />
        </div>
      </div>
    )
  );
};

export default observer(ProcessLayout);
